import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const vuetifyPlugin = {
  install (Vue, option) {
    Vue.use(Vuetify, {
      theme: {
        achBlack: '#1e1e1e',
        achBlack2: '#424242',
        achGray: '#d8d8d8',
        achGray2: '#e6e6e6',
        achGray3: '#F4F4F4',
        achGray4: '#979797',
        achGreen: '#00bfa5',
        achGreen2: '#009688',
        achGreen3: '#B8E986',
        achGreen4: '#4CC9D4',
        achRed: '#ea6a54',
        achYellow: '#fccf00',
        achYellow2: '#feaa00',
        achYellow3: '#ffe389',
        achYellow4: '#fff4d0',
        achWhite: '#ffffff',
        achGraphicColor1: '#1aadc7',
        achGraphicColor2: '#fed53a',
        achGraphicColor3: '#e4690e',
        achGraphicColor4: '#e2dacf',
        achGraphicColor5: '#ffe800',
        achGraphicColor6: '#c5d340',
        achGraphicColor7: '#089082',
        achGraphicColor8: '#59585a',
        achGraphicColor9: '#97c464',
        achGraphicColor10: '#235c97'
      }
    })
  }
}

export default vuetifyPlugin
